export default "__VITE_ASSET__DuFCRD3o__"